import { css } from 'lit';
export const CopyrightStyles = css `
    :host {
      position: relative;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .copyright-container {
        text-align: center;
        color: #9ca3af; 
        font-size: 0.75rem;
        margin-top: 1.5rem;
        margin-bottom: 1rem;
    }

    .copyright-container a {
      color: #4b5563; /* gray-600 */
      text-decoration: none;
      margin-left: 0.5rem;
      transition: color 0.2s ease-in-out;
    }

    .copyright-container a:hover {
      color: #111827; /* gray-900 */
      text-decoration: underline;
    }

    .separator {
      margin: 0 0.25rem;
    }
  `;
